import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, Mail, Phone, MapPin, Linkedin, Facebook, Instagram, MessageSquare } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0F2A4A] text-white/80 mt-auto" data-testid="site-footer">
      <div className="ae-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-[#C5A059] flex items-center justify-center">
                <Briefcase className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="font-heading font-semibold text-white text-lg">Achievers</div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-[#C5A059]">Enterprise</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed">
              India's trusted recruitment consultancy — connecting talent with opportunities across industries.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com/company/achievers-enterprise/", label: "linkedin" },
                { Icon: Facebook, href: "https://www.facebook.com/achieversenterpriseinfo/", label: "facebook" },
                { Icon: Instagram, href: "https://instagram.com/achievers.enterprise/", label: "instagram" },
                { Icon: MessageSquare, href: "https://join.skype.com/invite/vp2jbTXl0FIW", label: "skype" },
              ].map(({ Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer"
                  data-testid={`social-${label}`}
                  className="w-9 h-9 rounded-lg border border-white/15 flex items-center justify-center hover:bg-[#C5A059] hover:border-[#C5A059] transition-all">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-[#C5A059]">About Us</Link></li>
              <li><Link to="/services" className="hover:text-[#C5A059]">Services</Link></li>
              <li><Link to="/for-employers" className="hover:text-[#C5A059]">For Employers</Link></li>
              <li><Link to="/contact" className="hover:text-[#C5A059]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Industries</h4>
            <ul className="space-y-3 text-sm">
              {["IT & Technology", "Manufacturing", "Pharma & Healthcare", "Finance & Banking", "HVAC & MEP", "E-commerce"].map(i => (
                <li key={i} className="hover:text-[#C5A059]"><Link to="/jobs">{i}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#C5A059] flex-shrink-0" /> SF-17, 2nd Floor, JP Complex, Opp. Naroda Old Police Station, Naroda, Ahmedabad – 382 330</li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#C5A059]" /> <a href="tel:+919099042472" className="hover:text-[#C5A059]">+91 90990 42472</a></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#C5A059]" /> <a href="tel:+918320092044" className="hover:text-[#C5A059]">+91 83200 92044</a></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#C5A059]" /> <a href="mailto:achieversenterpriseinfo@gmail.com" className="hover:text-[#C5A059] break-all">achieversenterpriseinfo@gmail.com</a></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#C5A059]" /> <a href="mailto:HR.kuldipsinh@achieversenterprise.in" className="hover:text-[#C5A059] break-all">HR.kuldipsinh@achieversenterprise.in</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Achievers Enterprise. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#C5A059]">Privacy Policy</a>
            <a href="#" className="hover:text-[#C5A059]">Terms of Service</a>
            <a href="#" className="hover:text-[#C5A059]">GDPR</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
